import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Mutual Fund Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const MutualFundView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="mutual-funds"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default MutualFundView;
